import React from "react";
import PropTypes from "prop-types";
import compose from "recompose/compose";
import axios from "axios";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";

import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import InputLabel from "@material-ui/core/InputLabel";
import LockIcon from "@material-ui/icons/LockOutlined";
import Paper from "@material-ui/core/Paper";
import PersonIcon from "@material-ui/icons/PersonOutline";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";

import withStyles from "@material-ui/core/styles/withStyles";
import ThemeProvider from "@material-ui/styles/ThemeProvider";
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";

import defaultTheme from "../theme";

import { Notification, login as loginAction, forgotPassword as forgotPasswordAction, changePassword as changePasswordAction } from "jazasoft";
import { isEmpty } from "../utils/helpers";

import { authUrl } from "../App";

const appId = "optacut";

const extractClientId = location => {
  if (!location) return;
  let clientId;
  if (location.search && location.search.includes("c=")) {
    let param = location.search.split("&").find(s => s.includes("c="));
    if (param) {
      clientId = param.split("=")[1];
    }
  }
  return clientId;
};

function isValidPassword(password) {
  if (isEmpty(password)) return false;

  if (password.length > 15) {
    return false;
  }
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/;
  return regex.test(password);
}

const extractTenantId = props => {
  let tenantId = props.match.params && props.match.params["tenantId"];
  if (!tenantId && props.location.search && (props.location.search.includes("tenantId") || props.location.search.includes("t="))) {
    let param = props.location.search.split("&").find(s => s.includes("tenantId") || s.includes("t="));
    if (param) {
      tenantId = param.split("=")[1];
    }
  }
  return tenantId;
};

const validate = values => {
  const errors = {};

  if (!values.username) {
    errors.username = "Username/Email Required.";
  }

  if (!values.password) {
    errors.password = "Password Required.";
  }
  return errors;
};

const renderInput = ({ input, meta: { touched, error }, label, type, autoFocus, autoComplete, adorment, ...custom }) => (
  <FormControl margin="normal" error={touched && error !== undefined} required fullWidth>
    <InputLabel htmlFor={"name-error-" + input.name}>{label}</InputLabel>
    <Input
      id={input.name}
      type={type}
      autoComplete={autoComplete}
      autoFocus={autoFocus}
      endAdornment={<InputAdornment position="end">{adorment}</InputAdornment>}
      {...input}
    />
    {touched && error && <FormHelperText id="name-error-text">{error}</FormHelperText>}
  </FormControl>
);

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.primary.main,
    padding: 10,
    height: "100vh"
  },
  layout: {
    width: "auto",
    display: "block", // Fix IE11 issue.
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    [theme.breakpoints.up(400 + theme.spacing(3) * 2)]: {
      width: 400,
      marginLeft: "auto",
      marginRight: "auto"
    }
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: "100%", // Fix IE11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    marginTop: theme.spacing(3)
  }
});

class Login extends React.Component {
  state = {
    dialogActive: false,
    resend: false,
    error: {},
    username: null,
    otp: null,
    oldPassword: null,
    newPassword: null,
    confirmPassword: null,
    requireStrongPassword: null
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const action = this.props.authState.action;
    const nextAction = nextProps.authState.action;
    const credentialsExpired = nextProps.authState.credentialsExpired;

    if (nextAction === "confirm_otp") {
      this.setState({ resend: false });
      setTimeout(() => this.setState({ resend: true }), 30000);
    }
    if (action !== nextAction && action === "change_password") {
      this.onClose();
    }
    if (nextAction === "change_password" && credentialsExpired) {
      this.setState({ dialogActive: true });
      this.checkUser();
    }
  }

  onSubmit = values => {
    let tenantId = extractTenantId(this.props);
    let clientId = extractClientId(this.props.location);
    this.setState({ username: values.username });
    this.props.login({ ...values, tenantId, clientId }, "/", this.props.locale);

    setTimeout(() => {
      const serializedState = localStorage.getItem(`authState_${appId}`);
      if (serializedState) {
        const authState = JSON.parse(serializedState);
        const tenantId = authState?.tenant?.tenantId;
        if (tenantId) {
          localStorage.setItem(`${appId}-tenantId`, `${tenantId}`);
        }
      }
    }, 1000);
  };

  onDialogSubmit = action => async () => {
    const { credentialsExpired } = this.props.authState;
    const { username, otp, oldPassword, newPassword, confirmPassword, requireStrongPassword } = this.state;
    let error = {};
    action = action || "send_otp";
    //validate
    if (action === "send_otp" && !username) {
      error.username = "Username Required.";
    } else if (action === "confirm_otp" && !otp) {
      error.otp = "OTP Required.";
    } else if (action === "change_password") {
      if (credentialsExpired && !oldPassword) {
        error.oldPassword = "Old Password Required.";
      } else if (!newPassword) {
        error.newPassword = "New Password Required.";
      } else if (newPassword.length < 8) {
        error.newPassword = "The password is too short. It must be atleast 8 characters.";
      } else if (newPassword.length > 15) {
        error.newPassword = "The password is too Long. It must be less then 15 characters";
      } else if (!confirmPassword) {
        error.newPassword = "Confirm Password Required.";
      } else if (newPassword !== confirmPassword) {
        error.confirmPassword = "Password do not match.";
      } else if (!isEmpty(confirmPassword) && requireStrongPassword === true && !isValidPassword(confirmPassword)) {
        error.confirmPassword =
          "Password must be between 8 and 15 characters and include at least one uppercase letter, one lowercase letter, one number, and one special character (e.g., Demo@843)";
      }
    }
    if (Object.keys(error).length > 0) {
      this.setState({ error });
      return;
    }
    this.checkUser();

    let tenantId = extractTenantId(this.props);
    if (action === "change_password" && credentialsExpired) {
      const uName = this.props.formData && this.props.formData.username;
      this.props.changePassword({
        username: uName,
        oldPassword,
        newPassword,
        tenantId
      });
    } else {
      this.props.forgotPassword({
        action,
        username,
        otp,
        newPassword,
        tenantId
      });
    }
  };

  checkUser = () => {
    const { username, requireStrongPassword } = this.state;
    if (requireStrongPassword === null && !isEmpty(username)) {
      axios.get(`${authUrl}/api/users/check`, { params: { username, appId } }).then(response => {
        this.setState({ requireStrongPassword: response.data?.requireStrongPassword });
      });
    }
  };

  onChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
      error: { ...this.state.error, [event.target.name]: undefined }
    });
  };

  onClose = () => {
    this.setState({
      dialogActive: false,
      username: null,
      otp: null,
      newPassword: null,
      confirmPassword: null,
      requireStrongPassword: null,
      error: {}
    });
  };

  onForgotClick = () => {
    this.setState({ dialogActive: true });
  };

  renderDialog = () => {
    const { busy, action, credentialsExpired } = this.props.authState;
    return (
      <Dialog open={this.state.dialogActive} onClose={this.onClose} aria-labelledby="form-dialog-title" maxWidth="sm" fullWidth>
        <DialogTitle id="form-dialog-title">{credentialsExpired ? "Change Password" : "Forgot Password"}</DialogTitle>
        <DialogContent>
          {(!action || action === "send_otp") && (
            <TextField
              error={this.state.error.username}
              helperText={this.state.error.username}
              autoFocus
              margin="dense"
              id="username"
              name="username"
              label="Username"
              type="text"
              fullWidth
              onChange={this.onChange}
            />
          )}
          {action === "confirm_otp" && (
            <TextField
              error={this.state.error.otp}
              helperText={this.state.error.otp}
              autoFocus
              margin="dense"
              id="otp"
              name="otp"
              label="OTP"
              type="text"
              fullWidth
              onChange={this.onChange}
            />
          )}
          {action === "change_password" && credentialsExpired && (
            <TextField
              error={this.state.error.oldPassword}
              helperText={this.state.error.oldPassword}
              autoFocus
              margin="dense"
              id="oldPassword"
              name="oldPassword"
              label="Old Password"
              type="password"
              fullWidth
              onChange={this.onChange}
            />
          )}
          {action === "change_password" && (
            <TextField
              error={this.state.error.newPassword}
              helperText={this.state.error.newPassword}
              autoFocus={!credentialsExpired}
              margin="dense"
              id="newPassword"
              name="newPassword"
              label="New Password"
              type="password"
              fullWidth
              onChange={this.onChange}
            />
          )}
          {action === "change_password" && (
            <TextField
              error={this.state.error.confirmPassword}
              helperText={this.state.error.confirmPassword}
              margin="dense"
              id="confirmPassword"
              name="confirmPassword"
              label="Confirm Password"
              type="password"
              fullWidth
              onChange={this.onChange}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={this.onClose} color="primary">
            Cancel
          </Button>
          {action === "confirm_otp" && (
            <Button disabled={!this.state.resend} onClick={this.onDialogSubmit("resend_otp")} color={this.state.resend ? "primary" : "default"}>
              Resend
            </Button>
          )}
          <Button disabled={busy} onClick={this.onDialogSubmit(action)} color="primary">
            {busy && <CircularProgress size={20} />}
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  render() {
    const {
      classes,
      handleSubmit,
      authState: { busy }
    } = this.props;

    return (
      <React.Fragment>
        <CssBaseline />
        <div className={classes.root}>
          <main className={classes.layout}>
            <Paper className={classes.paper}>
              <Avatar className={classes.avatar}>
                <LockIcon />
              </Avatar>
              <Typography variant="h5">Sign in</Typography>
              <form className={classes.form} onSubmit={handleSubmit(this.onSubmit)}>
                <Field
                  name="username"
                  component={renderInput}
                  label="Username"
                  type="text"
                  autoComplete="username"
                  autoFocus
                  adorment={<PersonIcon />}
                />
                <Field
                  name="password"
                  component={renderInput}
                  label="Password"
                  type="password"
                  autoComplete="current-password"
                  adorment={<LockIcon />}
                />
                <div style={{ marginTop: 8 }} onClick={this.onForgotClick}>
                  <Typography component="a" color="primary">
                    Forgot password?
                  </Typography>
                </div>
                <Button type="submit" fullWidth variant="contained" disabled={busy} color={busy ? "default" : "primary"} className={classes.submit}>
                  {busy && <CircularProgress color="secondary" size={20} />}
                  Sign in
                </Button>
                {this.renderDialog()}
              </form>
            </Paper>
            <Notification />
          </main>
        </div>
      </React.Fragment>
    );
  }
}

Login.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  authState: state.jazasoft.auth || {},
  formData: state.form && state.form.login && state.form.login.values,
  locale: state.i18n?.locale
});

const EnhancedLogin = compose(
  connect(mapStateToProps, {
    login: loginAction,
    forgotPassword: forgotPasswordAction,
    changePassword: changePasswordAction
  }),
  reduxForm({
    form: "login",
    validate
  }),
  withStyles(styles)
)(Login);

const ThemedLogin = ({ theme = defaultTheme, ...rest }) => (
  <ThemeProvider theme={createMuiTheme(theme)}>
    <EnhancedLogin {...rest} />
  </ThemeProvider>
);

export default ThemedLogin;
